module.exports = __webpack_public_path__ + "static/media/FavNote.bdd3c2e0.svg";